module.exports = __webpack_public_path__ + "static/media/fanl_bg.70fe42b7.png";